import validatorContent from "../content/validator";

const maxSizeLimitation = 12000;
const minSizeLimitation = 1;

export const warningText = {
    "isBigget": `Maximum size is ${maxSizeLimitation}px`,
    "isSmall": `Mininmum size is ${minSizeLimitation}px`,
    "isNotNumber": "Value is not a number",
  }

const ValidatorHelper = () => {
    const validateFormatFile = (image) => {
        return image.length > 0
    }

    return { validateFormatFile };
}


export const validateDimention = (property, value): {isValid: boolean, type: string, description: string} => {
    if (isNaN(+value)) return { isValid: false, type: 'isNotNumber', description: ''} 

    if (value < minSizeLimitation) return { isValid: false, type: `isSmall`, description: warningText['IsSmall']}

    if (value > maxSizeLimitation) return { isValid: false, type: `isBigget`, description: warningText['isBigget']}    

    return { isValid: true, type: '', description: ''}
}

export const validateCropDimention = (imageWidth, imageHeight, cropWidth, cropHeight) => {

    if (imageWidth < cropWidth) return { isValid: false, input:"width", type: `isBigget`, description: `Maximum size is ${imageWidth}px`}
    if ( 1 > cropWidth) return { isValid: false, input:"width", type: `isSmall`, description: `Minimum size is 1px`}
    

    if (imageHeight < cropHeight) return { isValid: false, input:"height", type: `isBigget`, description: `Maximum size is “${imageHeight}px`}
    if ( 1 > cropHeight) return { isValid: false, input:"height", type: `isSmall`, description: `Minimum size is 1px`}
    

    return { isValid: true, input:"input", type: '', description: ''}
}

export default ValidatorHelper;